import { useState, useEffect } from "react";
import axios from "axios";

import { BACKEND_CONFIG, SURPLUS_LINES_ROUTING } from "../../../config/consts";

type PaymentPlanSelectProps = {
  onChange: (plan: string) => void;
  error: boolean;
  SurplusLines: boolean;
};

type PlanOption = {
  Name: string;
  Value: string;
};

export function PaymentPlanSelect({
  onChange,
  error,
  SurplusLines,
}: PaymentPlanSelectProps) {
  const [plans, setPlans] = useState([] as PlanOption[]);

  useEffect(() => {
    const useSurplusRouting = SURPLUS_LINES_ROUTING && SurplusLines;

    const paymentList = useSurplusRouting
      ? "surpluslinespaymentplans"
      : "paymentplans";

    axios
      .get(BACKEND_CONFIG.apiUrl + "listitems/" + paymentList)
      .then((response) => setPlans(response.data));
  }, []);

  return (
    <div className="form-group">
      <label>Payment Plan:</label>
      <select defaultValue={""} onChange={(e) => onChange(e.target.value)}>
        <option value="" className="default-option" disabled>
          Select Payment Plan
        </option>
        {plans.map((plan) => (
          <option value={plan.Value} key={plan.Value}>
            {plan.Name}
          </option>
        ))}
      </select>
      {error && <div className="error">Please select Payment Plan</div>}
    </div>
  );
}

type DownpaymentInputProps = {
  error: boolean;
  onChange: (down: string) => void;
};

export function DownpaymentInput({ error, onChange }: DownpaymentInputProps) {
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  }

  return (
    <div className="form-group">
      <label>Down Payment:</label>
      <div className="input-group">
        <div className="input-group-prepend">
          <span
            className="input-group-text"
            style={{ padding: ".3rem .75rem" }}
          >
            $
          </span>
        </div>
        <input
          onChange={handleInputChange}
          type="number"
          className="form-control"
          placeholder="Amount"
          style={{
            width: "87%",
            margin: 0,
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
          }}
        />
      </div>
      <div className={!error ? "hide-item" : "error"}>
        Please enter a down payment
      </div>
    </div>
  );
}
